import React, { useReducer, useRef, useState, useContext } from 'react'
import moment from 'moment'
import 'moment/locale/es'
import styles from './Pago.module.css'
import Modal from './modal/visa'
import * as PagoReducer from '../../store/reducers/pagoReducer'
import * as PagoActions from '../../store/actions/pagoActions'
import stylesSuccesPayment from '../../pages/ConfirmacionPago/ConfirmacionPago.module.css'
import GeneralContext from '../../context/GeneralContext'
import ReintentoServicio from '../../components/ReintentoServicio'
import * as Funciones from '../../utils/funciones'
import PagoLinkExitoso from '../PagoLinkExitoso/PagoLinkExitoso'
import * as Constantes from '../../utils/constantes'
import * as GeneralActions from '../../store/actions/generalActions'
import * as PrimerPagoRepository from '../../services/repositories/primer-pago-repository'

moment.locale('es')

let imagenNiubiz = require('../../img/niubiz.png')
let imagenSafetyPay = require('../../img/pagosafety.png')
let imagenPagoLink = require('../../img/link.png')

const Pago = ({ data, onPayment, statePadre, setState }) => {
    const elementStyles = {
        base: {
            color: '#666666',
            fontWeight: 400,
            fontFamily: "'Montserrat', sans-serif",
            fontSize: '16px',
            fontSmoothing: 'antialiased',
            placeholder: {
                color: '#999999'
            },
            autofill: {
                color: '#e39f48'
            }
        },
        invalid: {
            color: '#E25950',
            '::placeholder': {
                color: '#FFCCA5'
            }
        }
    }

    const initialState = {
        visa: {
            numeroPedido: null,
            numeroTarjeta: null,
            sessionToken: null,
            mostrarFormulario: false,
            card: null,
            cargandoPago: false,
            errorVisa: null
        }
    }

    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    const [state, dispatch] = useReducer(PagoReducer.PagoReducer, PagoReducer.initialState)
    const [mostrarModal, setMostrarModal] = useState(false)
    const [loadingIcon, setLoadingIcon] = useState(false)
    const [errorSafetyPay, setErrorSafetyPay] = useState(false)
    const [errorPagoLink, setErrorPagoLink] = useState(false)
    const [estadoPagoLink, setEstadoPagoLink] = useState('') //estado para mostrar la consulta de verificar pago
    const [localState, setLocalState] = useState(initialState)

    const botonNiubizRef = useRef()
    const botonSafetyPayRef = useRef()
    const botonPagoLinkRef = useRef()

    useState(() => {
        if (data.payedVisa) {
            dispatch(PagoActions.setTipoMercado(true, false, false))
            const obj = {
                transactionIdentifier: data.payedVisa.codigoSafetyPay,
                currency: data.currency,
                amount: data.amount.toLocaleString('en-US', { minimumFractionDigits: 2 }),
                fechaPago: `${moment(new Date(data.payedVisa.fechaPago)).format('YYYY-MM-DD')} ${moment(new Date(data.payedVisa.fechaPago)).format('HH:mm:ss')}`
            }
            dispatch(PagoActions.setDataVisa(obj))
        }

        if (data.payed) {
            dispatch(PagoActions.setTipoMercado(false, true, false))
            let fechas = data.payed.fechaVencimientoSafetyPay.split('-')
            let vencimiento = fechas[2] + ' de ' + Constantes.MESES[parseInt(fechas[1]) - 1] + ' ' + fechas[0]

            const obj = {
                transactionIdentifier: data.payed.codigoSafetyPay,
                currency: data.currency,
                amount: data.amount.toLocaleString('en-US', { minimumFractionDigits: 2 }),
                expiration: vencimiento//`${moment(new Date(data.payed.fechaVencimientoSafetyPay)).format('DD MMM')} - ${moment(new Date(data.payed.fechaPago)).format('hh:mm')}${moment(new Date(data.payed.fechaPago)).format('a')}`,
            }
            dispatch(PagoActions.setDataSafetyPay(obj))
        }

        //Pago Link
        if (data.payedPagolink) {
            dispatch(PagoActions.setTipoMercado(false, false, true))
            const obj = {
                transactionIdentifier: 'NO_EXISTE',
                currency: data.currency,
                amount: Funciones.mostrarFormatoMoneda(data.amount),
                expiration: new Date()
            }
            dispatch(PagoActions.setDataPagoLink(obj))
        }
    }, [])

    const activarEspera = (tiempoMseg) => {
        setState((state) => {
            return {
                ...state,
                estaCargando: true
            }
        })

        setTimeout(() => {
            setState((state) => {
                return {
                    ...state,
                    estaCargando: false
                }
            })
        }, tiempoMseg);
    }

    const handleVisaSeleccion = () => {
        dispatch(PagoActions.setTipoMercado(true, false, false))
    }

    const handleSafetyPaySeleccion = () => {
        dispatch(PagoActions.setTipoMercado(false, true, false))
    }

    const handlePagoLinkSeleccion = () => {
        dispatch(PagoActions.setTipoMercado(false, false, true))
    }

    const handleRealizarPago = () => {
        if (!state.tipoMercadoVisa && !state.tipoMercadoSafetyPay && !state.tipoMercadoPagoLink) {
            dispatch(PagoActions.setMensajeError('Debe seleccionar el mercado a pagar.'))
        }
        setErrorSafetyPay(false)
        setErrorPagoLink(false)
        if (state.tipoMercadoVisa) {
            setLoadingIcon(true)
            handleRealizarPagoVisa()
        }
        if (state.tipoMercadoSafetyPay) {
            setLoadingIcon(true)
            handleRealizarPagoSafetyPay()
        }
        if (state.tipoMercadoPagoLink) {
            setLoadingIcon(true)
            handleRealizarPagoLink()
        }
    }

    const handleRealizarPagoSafetyPay = async () => {
        const obj = {
            "idSolicitudMultiple": cotizacion.idSolicitudMultiple,
            "moneda": {
                "codigo": data.currency === 'S/' ? 2 : 1,
                "descripcion": data.description
            },
            "monto": Number(data.amount.toFixed(2))
        }

        const response = await PrimerPagoRepository.pagarSafetyPay(obj)
        if (response.error === null) {
            let fechaActual = new Date()
            const arrPay = []
            let dia = fechaActual.getDate().toString()
            let mes = (fechaActual.getMonth() + 1).toString()
            if (mes.length < 2)
                mes = '0' + mes
            if (dia.length < 2)
                dia = '0' + dia
            let hora = moment(response.safetypay.expirationDateTime.split(' ')[5], 'HH:mm a').format('HH:mm:ss')
            let fecha = fechaActual.getFullYear() + '-' + mes + '-' + dia
            const arrDate = []
            arrDate.push(fecha, hora)
            const formatedDate = arrDate.join('T')

            /*Fecha de vencimiento - INI*/
            let fechaVen = response.safetypay.expirationDateTime.split('(')[0].split(' ')
            let mesV = (Constantes.MESES.indexOf(fechaVen[3]) + 1).toString()
            let diaV = fechaVen[1]
            if (mesV.length < 2)
                mesV = '0' + mesV
            if (diaV.length < 2)
                diaV = '0' + diaV

            let año = fechaActual.getMonth() === 11 ? fechaActual.getFullYear() + 1 : fechaActual.getFullYear()
            let fechaVF = año.toString() + '-' + mesV + '-' + diaV

            const arrDateV = []
            arrDateV.push(fechaVF, hora)
            /**Fecha de vencimiento - FIN */

            data.id.map((id) => {
                arrPay.push({
                    "usuario": `${prospecto.idProspecto}`,
                    "idSolicitud": id,
                    "cobranzaPrimeraCuota": { // 8 safetypay y 9 visa
                        "codigo": 8,
                        "descripcion": "Safety Pay"
                    },
                    "entidadPrimeraCuota": {
                        "codigo": 0,
                        "descripcion": ""
                    },
                    "codigoSafetyPay": response.safetypay.transactionIdentifier,
                    "fechaVencimientoSafetyPay": fechaVF,
                    "fechaPago": formatedDate,
                    "numeroOperacionTarjeta": null //CMUNAYLLA: cuando es pago safetypay, este campo se envia con valor null
                })
                return id
            })

            const putPago = await PrimerPagoRepository.registrarPagos(arrPay, cotizacion.idSolicitudMultiple)
            if (putPago.error === null) {
                const objRes = {
                    transactionIdentifier: response.safetypay.transactionIdentifier,
                    currency: data.currency,
                    amount: response.safetypay.paymentsAmounts[data.currencyID === 'USD' ? 1 : 0].monto.toLocaleString('en-US', { minimumFractionDigits: 2 }),
                    //expiration: `${moment(new Date(response.safetypay.responseDateTime)).format('DD MMM')} - ${response.safetypay.expirationDateTime.split(' ')[5]}`,
                    expiration: response.safetypay.expirationDateTime.split('(')[0].slice(0, -1)
                }
    
                dispatch(PagoActions.setDataSafetyPay(objRes))
                onPayment({
                    codigoSafetyPay: data.payed.codigoSafetyPay,
                    fechaVencimientoSafetyPay: data.payed.fechaVencimientoSafetyPay,
                    fechaPago: data.payed.fechaPago,
                    currency: data.currency,
                }, state.tipoMercadoSafetyPay, false, false)
            } else {
                generalDispatch(GeneralActions.updateError(putPago.error, '¡Alerta!', true))
            }
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
        }   
    }

    //IMPLEMENTACION SERVICIO PAGO LINK
    const handleRealizarPagoLink = async () => {
        const obj = {
            "idSolicitudMultiple": cotizacion.idSolicitudMultiple,
            "solicitudes": data.id,
            "monto": Number(data.amount.toFixed(2)),
            "codigoMoneda": data.currency === 'S/' ? 2 : 1,
            "cliente": {
                "tipoDocumento": cotizacion.contratante.tipoDocumento.codigo,
                "numeroDocumento": cotizacion.contratante.numeroDocumento,
                "nombres": cotizacion.contratante.nombres,
                "apellidos": cotizacion.contratante.apellidoPaterno + ' ' + cotizacion.contratante.apellidoMaterno,
                "email": cotizacion.contratante.contacto.email,
                "celular": cotizacion.contratante.contacto.celular
            }
        }

        const response = await PrimerPagoRepository.pagarPagoLink(obj)
        if (response.error === null) {
            let objRes = {
                transactionIdentifier: 'NO_EXISTE',
                currency: data.currency,
                amount: Funciones.mostrarFormatoMoneda(data.amount),
                expiration: new Date()
            }
            dispatch(PagoActions.setDataPagoLink(objRes))

            onPayment({
                currency: data.currency,
                mensajeExito: response.pagolink
            }, false, false, state.tipoMercadoPagoLink)
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
        }
    }

    //CODIGOO VISA
    const handleRealizarPagoVisa = async () => {
        const importarConfiguracionVisa = async (sessionToken) => {
            return new Promise((resolve) => {
                if (window.payform) {
                    setLocalState((localState) => {
                        return {
                            ...localState,
                            visa: {
                                ...localState.visa,
                                mostrarFormulario: true
                            }
                        }
                    })
                    resolve()
                } else {
                    const script = document.createElement('script')
                    script.src = process.env.REACT_APP_SRC_NIUBIZ
                    script.id = 'myScript'
                    script.async = true
                    script.onload = () => cargarScriptConfiguracion(sessionToken)
                    document.head.appendChild(script)
                    resolve()
                }
            })
        }

        const cargarScriptConfiguracion = (sessionToken) => {
            try {
                let numeroPedido = Funciones.generarCorrelativoVisa()
                let configuration = {
                    sessionkey: sessionToken,
                    channel: "web",
                    merchantid: data.codMoneda === 1 ? process.env.REACT_APP_MERCHANT_ID_DOLARES : process.env.REACT_APP_MERCHANT_ID_SOLES,
                    purchasenumber: numeroPedido,
                    amount: Funciones.formatearMonedaVisa(data.amount),
                    language: "es", // esto falta en su documentación de nibubiz
                    merchantConfiguration: {
                        recurrencyEnabled: false,
                        tokenizationEnabled: false,
                    },
                    font: "https://fonts.googleapis.com/css?family=Montserrat:400&display=swap"
                };
                window.configuration = configuration
                window.payform.setConfiguration(configuration)
                crearFormularioVisa()

                setLocalState((localState) => {
                    return {
                        ...localState,
                        visa: {
                            ...localState.visa,
                            numeroPedido: numeroPedido
                        }
                    }
                })
            } catch (error) {
                console.error('ERROR:', error)
            }
        }

        const crearFormularioVisa = () => {
            activarEspera(3000)
            window.cardNumber = window.payform.createElement('card-number', {
                style: elementStyles,
                placeholder: 'Número de Tarjeta'
            }, 'txtNumeroTarjeta');
            window.cardCvv = window.payform.createElement('card-cvc', {
                style: elementStyles,
                placeholder: 'CVV'
            }, 'txtCvv');
            window.cardExpiry = window.payform.createElement('card-expiry', {
                style: elementStyles,
                placeholder: 'MM/AA'
            }, 'txtFechaVencimiento');

            window.cardNumber.then(element => {
                element.on('bin', function (data) {
                    setLocalState((localState) => {
                        return {
                            ...localState,
                            visa: {
                                ...localState.visa,
                                numeroTarjeta: data
                            }
                        }
                    })
                });

                element.on('change', function (data) {
                    setLocalState((localState) => {
                        return {
                            ...localState,
                            visa: {
                                ...localState.visa,
                                errorVisa: data[0] === undefined || data[0] === null ?
                                    null : data[0].es.message
                            }
                        }
                    })
                });
            })

            setLocalState((localState) => {
                return {
                    ...localState,
                    visa: {
                        ...localState.visa,
                        mostrarFormulario: true
                    }
                }
            })
        }

        const obtenerTokenSesionNiubiz = async () => {
            let request = {
                monto: data.amount,
                codigoMoneda: data.codMoneda,
                email: cotizacion.contratante.contacto.email
            }

            //Obtener Token Api Visa
            const response = await PrimerPagoRepository.obtenerTokenNiubiz(request)
            if (response.error === null) {
                let sessionKey = response.token.sessionKey
                await importarConfiguracionVisa(sessionKey)
                setLocalState((localState) => {
                    return {
                        ...localState,
                        visa: {
                            ...localState.visa,
                            sessionToken: sessionKey,
                            errorVisa: null
                        }
                    }
                })
            } else {
                setLoadingIcon(false)
                setLocalState((localState) => {
                    return {
                        ...localState,
                        visa: {
                            ...localState.visa,
                            sessionToken: null,
                            //errorVisa: resTokenVisa.mensajeError
                        }
                    }
                })
                generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
            }
        }

        await obtenerTokenSesionNiubiz()
    }

    const reiniciarPagoVisa = () => {
        window.payform.resetData([window.cardNumber])
        window.payform.resetData([window.cardExpiry])
        window.payform.resetData([window.cardCvv])

        setLocalState((localState) => {
            return {
                ...localState,
                visa: {
                    ...localState.visa,
                    sessionToken: null,
                    cargandoPago: false,
                    mostrarFormulario: false,
                    errorVisa: null
                }
            }
        })
    }

    const pagarDeNuevo = () => {
        setLoadingIcon(false)
        reiniciarPagoVisa()

        //Se reinicia la página de pago temporalmente para un futura adecuacion mejor de solucion
        window.location.reload()
        setState((statePadre) => {
            return {
                ...statePadre,
                estaCargando: true
            }
        })

    }

    //Funcion para invocar pago por niubiz
    const pagarVisa = async () => {
        const registrarPago = async (resAutorizacionNuibiz) => {
            let arrPay = []
            data.id.map((id) => {
                arrPay.push({
                    "usuario": `${prospecto.idProspecto}`,
                    "idSolicitud": id,
                    "cobranzaPrimeraCuota": { // 8 safetypay y 9 visa
                        "codigo": 9,
                        "descripcion": "Visa Click App"
                    },
                    //CMUNAYLLA: se agregan los valores correspondientes en codigo y descripcion
                    "entidadPrimeraCuota": {
                        "codigo": resAutorizacionNuibiz.brand === 'visa' ? 101 : resAutorizacionNuibiz.brand === 'mastercard' ? 102 :
                            resAutorizacionNuibiz.brand === 'amex' ? 103 : resAutorizacionNuibiz.brand === 'dinersclub' ? 104 :
                                resAutorizacionNuibiz.brand === null ? 107 : 0,
                        "descripcion": resAutorizacionNuibiz.brand === 'visa' ? 'VISA' : resAutorizacionNuibiz.brand === 'mastercard' ? 'MASTERCARD' :
                            resAutorizacionNuibiz.brand === 'amex' ? 'AMERICAN EXPRESS' : resAutorizacionNuibiz.brand === 'dinersclub' ? 'DINERS' :
                                resAutorizacionNuibiz.brand === null ? 'VISA DOLARES' : ''
                    },
                    "codigoSafetyPay": null,//asrivera: cuando es pago Niubiz el parametro codigoSafetyPay se debe enviar null
                    "fechaVencimientoSafetyPay": new Date(),//asrivera: cuando es pago Niubiz el parametro fechaVencimientoSafetyPay debe enviarse la fecha actual por defecto
                    "fechaPago": new Date(),
                    "numeroOperacionTarjeta": localState.visa.numeroPedido //CMUNAYLLA: cuando es pago niubiz se envia este valor
                })
                return id
            })

            const resPutPayment = await PrimerPagoRepository.registrarPagos(arrPay, cotizacion.idSolicitudMultiple)
            if (resPutPayment.error === null) {
                let objRes = {
                    transactionIdentifier: resAutorizacionNuibiz.transactionId,
                    currency: data.currency,
                    amount: Funciones.mostrarFormatoMoneda(resAutorizacionNuibiz.amount),
                    expiration: Funciones.formatearExpiracionVisaDate(resAutorizacionNuibiz.expireOn)
                }

                dispatch(PagoActions.setDataVisa(objRes))

                onPayment({
                    codigoSafetyPay: resAutorizacionNuibiz.transactionId,
                    fechaVencimientoSafetyPay: resAutorizacionNuibiz.expireOn,
                    fechaPago: `${moment(new Date()).format('YYYY-MM-DD')} ${moment(new Date()).format('hh:mm:ss')}`, //CMUNAYLLA: se cambia formato de hora
                    currency: data.currency
                }, false, state.tipoMercadoVisa, false)

                setLoadingIcon(false)
                reiniciarPagoVisa()

                generalDispatch(GeneralActions.updateEstadoCargando(false))

                //CMUNAYLLA: se setea el valor a null para limpiar el formulario para el siguiente pago
                window.payform = null

            } else {
                generalDispatch(GeneralActions.updateError(resPutPayment.error, '¡Alerta!', true))
            }
        }

        const invocarAutorizacionNuibiz = async (idTokenProceso) => {
            let request = {
                idSolicitudMultiple: cotizacion.idSolicitudMultiple,
                tokenId: idTokenProceso,
                monto: data.amount,
                codigoMoneda: data.codMoneda,
                cardHolder: {
                    tipoDocumento: cotizacion.contratante.tipoDocumento.codigo,
                    numeroDocumento: cotizacion.contratante.numeroDocumento,
                    nombres: cotizacion.contratante.nombres,
                    apellidos: cotizacion.contratante.apellidoPaterno + ' '
                        + cotizacion.contratante.apellidoMaterno
                },
                numeroPedido: localState.visa.numeroPedido
            }

            const response = await PrimerPagoRepository.obtenerAutorizacionNiubiz(request)
            if (response.error === null) {
                await registrarPago(response.autorizacion)
            } else {
                setLocalState((localState) => {
                    return {
                        ...localState,
                        visa: {
                            ...localState.visa,
                            //errorVisa: resAutorizacionNiubiz.res.status === 400 ? 'Niubiz Authorization. mensaje: Not Authorized Tarjeta no valida'
                              //  : resAutorizacionNiubiz.mensajeError
                        }
                    }
                })

                generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
            }
        }

        const crearTokenTransaccionNuibiz = async () => {
            let datos = {
                name: cotizacion.contratante.nombres,
                lastName: cotizacion.contratante.apellidoPaterno,
                email: cotizacion.contratante.contacto.email,
                phoneNumber: cotizacion.contratante.contacto.celular,
                currencyConversion: false,
                recurrence: false,
                alias: 'sdweb-pacifico'
            }

            setState((statePadre) => {
                return {
                    ...statePadre,
                    estaCargando: true
                }
            })

            window.payform.createToken(
                [window.cardNumber, window.cardExpiry, window.cardCvv], datos
            ).then(function (data) {
                //Autorizacion Pago Niubiz
                /* CAMUNOZR - Posible perdida de Token de transacción */
                invocarAutorizacionNuibiz(data.transactionToken)
            }).catch((error) => {
                setLocalState((localState) => {
                    return {
                        ...localState,
                        visa: {
                            ...localState.visa,
                            //errorVisa: error
                        }
                    }
                })
                generalDispatch(GeneralActions.updateError(error, '¡Alerta!', true))
                /*setState((statePadre) => {
                    return {
                        ...statePadre,
                        estaCargando: false
                    }
                })*/
            })
        }

        generalDispatch(GeneralActions.updateEstadoCargando(true))
        await crearTokenTransaccionNuibiz()
    }

    //Funcion para verificar el estado del pago link
    const handleVerificarPagoLink = async () => {
        generalDispatch(GeneralActions.updateEstadoCargando(true))
        const response = await PrimerPagoRepository.validarPagoLink(cotizacion.idSolicitudMultiple)
        if (response.error === null) {
            /**en caso de respuesta exitosa, cambiar estado de cambio de pantalla */
            if (response.pagolink.length !== 0) {
                let valor = response.pagolink.filter(dato => dato.idSolicitud === data.id[0])[0]
                if (valor.estado === 'COMPLETED') {
                    setEstadoPagoLink(true)
                } else {
                    setEstadoPagoLink(false)
                }
            } else {
                generalDispatch(GeneralActions.updateError({mensajeRespuesta: Constantes.MENSAJE_ERROR_SERVICIO_500}, '¡Alerta!', true))
            }
            generalDispatch(GeneralActions.updateEstadoCargando(false))
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
        }
    }

    if (state.tipoMercadoVisa) {
        imagenNiubiz = require('../../img/niubiz.png')
        imagenSafetyPay = require('../../img/pagosafety.png')
        imagenPagoLink = require('../../img/link.png')
        if (botonNiubizRef.current || botonSafetyPayRef.current || botonPagoLinkRef.current) {
            botonNiubizRef.current.style.backgroundColor = 'white'
            botonSafetyPayRef.current.style.backgroundColor = ''
            botonPagoLinkRef.current.style.backgroundColor = ''
        }
    }

    if (state.tipoMercadoSafetyPay) {
        imagenNiubiz = require('../../img/niubiz.png')
        imagenSafetyPay = require('../../img/pagosafety.png')
        imagenPagoLink = require('../../img/link.png')
        if (botonNiubizRef.current || botonSafetyPayRef.current || botonPagoLinkRef.current) {
            botonNiubizRef.current.style.backgroundColor = ''
            botonSafetyPayRef.current.style.backgroundColor = 'white'
            botonPagoLinkRef.current.style.backgroundColor = ''
        }
    }

    if (state.tipoMercadoPagoLink) {
        imagenNiubiz = require('../../img/niubiz.png')
        imagenSafetyPay = require('../../img/pagosafety.png')
        imagenPagoLink = require('../../img/link.png')
        if (botonNiubizRef.current || botonSafetyPayRef.current || botonPagoLinkRef.current) {
            botonNiubizRef.current.style.backgroundColor = ''
            botonSafetyPayRef.current.style.backgroundColor = ''
            botonPagoLinkRef.current.style.backgroundColor = 'white'
        }
    }

    //PANTALLA DE PAGO EXITOSO NIUBIZ
    if (state.tipoMercadoVisa && state.data) { //CMUNAYLLA: se quita una validacion demas
        return (
            <div className={stylesSuccesPayment['areadatosprospecto']}>
                <p className={stylesSuccesPayment['titulopago']}>¡Pago Exitoso!</p>
                <div className={stylesSuccesPayment['areacardpago']}>
                    <div className={stylesSuccesPayment['areacardpagoapice']}></div>
                    <div className={stylesSuccesPayment['areacardpagocontenido']}>
                        <div className={stylesSuccesPayment['txtitempago']}>
                            <p>Resultado de la operación<br /><span>Operación Autorizada</span></p>
                            {/*Se agrega el nombre del contratante*/}
                            <p>Nombre del contratante<br />
                                <span>
                                    {(cotizacion.contratante.nombres).charAt(0) + (cotizacion.contratante.nombres).slice(1).toLowerCase() + ' '
                                        + (cotizacion.contratante.apellidoPaterno).charAt(0) + (cotizacion.contratante.apellidoPaterno).slice(1).toLowerCase() + ' '
                                        + (cotizacion.contratante.apellidoMaterno).charAt(0) + (cotizacion.contratante.apellidoMaterno).slice(1).toLowerCase()
                                    }
                                </span>
                            </p>
                            <p>Número de pedido<br />
                                <span>
                                    {/*CMUNAYLLA: se agrega la validacion para mostrar el numero de pedido */}
                                    {data.payedVisa.numeroOperacionTarjeta ? data.payedVisa.numeroOperacionTarjeta : localState.visa.numeroPedido}
                                </span>
                            </p>
                            <p>Número de tarjeta<br />
                                <span>
                                    {/*CMUNAYLLA: se agrega la validacion para mostrar el numero de tarjeta con 'X' */}
                                    {localState.visa.numeroTarjeta ? localState.visa.numeroTarjeta + '*****XXXX' : 'XXXXXXXXXXXXXXXX'}
                                </span>
                            </p>
                            <p>Fecha y hora del pedido<br /><span>{state.data.fechaPago ? state.data.fechaPago :
                                `${moment(new Date()).format('YYYY-MM-DD')} ${moment(new Date()).format('HH:mm:ss')}`}</span>
                            </p>
                        </div>
                        <div className={stylesSuccesPayment['txtitempago']}>
                            <p>Importe de la transacción<br /><span>{state.data.amount}</span></p>
                            <p>Moneda<br /><span>{state.data.currency === 'S/' ? 'Soles' : 'Dólares'}</span></p>
                            <p>Descripción del producto<br /><span>{data.description}</span></p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    //PANTALLA DE PAGO EXITOSO SAFETYPAY
    if (state.tipoMercadoSafetyPay && state.data && state.data?.transactionIdentifier) {
        return (
            <div className={stylesSuccesPayment['areadatosprospecto']}>
                <p className={stylesSuccesPayment['titulopago']}>¡Gracias!</p>
                <p className={stylesSuccesPayment['txtcompra']}>Tu compra será procesada cuando hayas realizado el pago en tu banco.</p>
                <div className={stylesSuccesPayment['areamotonpago']}>
                    <div className={stylesSuccesPayment['areamotonpagocolor1']}>
                        <p>Número de transacción</p>
                        <p className={stylesSuccesPayment['txtcompracolor']}>{state.data.transactionIdentifier}</p>
                    </div>
                    <div className={stylesSuccesPayment['areamotonpagocolor2']}>
                        <p>Monto total a pagar</p>
                        <p className={stylesSuccesPayment['txtcompracolor']}>{data.currency} {state.data.amount}</p>
                    </div>
                    <div className={stylesSuccesPayment['areamotonpagocolor1']}>
                        <p>La transacción expira</p>
                        <p className={stylesSuccesPayment['txtcompracolor']}>{state.data.expiration}</p>
                    </div>
                </div>
                <div className={stylesSuccesPayment['areamotonpago']}>
                    <div className={stylesSuccesPayment['vinetali']}>1</div><p className={stylesSuccesPayment['vinetalip']}>Selecciona <b>Transferencias y pagos - Pagos - Servicios</b></p>
                </div>
                <div className={stylesSuccesPayment['areamotonpago']}>
                    <div className={stylesSuccesPayment['vinetali']}>2</div><p className={stylesSuccesPayment['vinetalip']}>Servicios: <b>SafetyPay  - {state.data.transactionIdentifier}</b></p>
                </div>
            </div>
        )
    }

    //PANTALLA DE PAGO EXITOSOS PAGOLINK
    if (state.tipoMercadoPagoLink && state.data) {
        return <PagoLinkExitoso valores={cotizacion.contratante}
            monto={data.amount.toLocaleString('en-US', { minimumFractionDigits: 2 })}
            tipoMon={data.currency}
            accion={() => handleVerificarPagoLink()}
            estado={estadoPagoLink}
        />
    }

    return (
        <React.Fragment>
            
            <div style={{ position: 'absolute', top: '0px' }}>
                <ReintentoServicio
                    errorCargando={errorSafetyPay || errorPagoLink}
                    handleReintento={null}
                    tipoMensaje={3}
                />
            </div>
            <div className={styles['areadatosprospecto']}>
                <p className={styles['txtdetalledepago']}>Total a pagar <span>{data.currency} {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span></p>
                <p className={styles['txtsubtitulopago']}>Escoge tu medio de pago</p>
                <div className={styles['grupobtnpago']}>
                    <button className={state.tipoMercadoPagoLink ? styles['btn2'] : styles['btn']}
                        ref={botonPagoLinkRef}
                        onClick={handlePagoLinkSeleccion}
                    >
                        <img style={state.tipoMercadoPagoLink === true || state.tipoMercadoSafetyPay || state.tipoMercadoVisa ? { backgroundColor: '#fff !important' } : state.tipoMercadoPagoLink === false ? { backgroundColor: '#eee !important' } : null} src={imagenPagoLink} alt='' />
                    </button>
                    <br />
                    <button className={state.tipoMercadoVisa ? styles['btn2'] : styles['btn']}
                        ref={botonNiubizRef}
                        onClick={handleVisaSeleccion}
                    >
                        <img src={imagenNiubiz} alt='' />
                    </button>
                    <button className={state.tipoMercadoSafetyPay ? styles['btn2'] : styles['btn']}
                        ref={botonSafetyPayRef}
                        onClick={handleSafetyPaySeleccion}
                    >
                        <img src={imagenSafetyPay} alt='' />
                    </button>
                </div>
                <p className={styles['txtinfopagodetalle']}>
                    Declaro ser mayor de 18 años y conocer que la Compañía no procesará solicitudes
                    con datos, documentos o evaluaciones incompletas. Uno de los requisitos mínimos
                    para iniciar la evaluación de este documento es la recepción del primer pago de
                    la prima provisional. Sin perjuicio de ello, la Compañía podrá solicitar requisitos
                    adicionales. En caso la presente solicitud sea rechazada, la Compañía devolverá
                    el monto de la prima provisional que haya sido abonado sin intereses. Declaro
                    conocer que para cualquier consulta podré comunicarme al <b>513-5000</b> o a la
                    dirección electrónica <span>servicioalcliente@pacificovida.com.pe</span>
                </p>
                <div className={styles['grupobtnpago1']}>
                    {state.mensajeError && <span className={styles['form-error']}>{state.mensajeError}</span>}
                    <button
                        className={`${styles['btnpagoaccion']} ${loadingIcon
                            ? styles['btnpagoaccion--loading'] : ''}`} onClick={handleRealizarPago}>
                        Acepto Términos y Pagar
                    </button>
                </div>
            </div>
            {mostrarModal && (
                <Modal
                    mostrarModal={mostrarModal}
                    setModal={setMostrarModal}
                />
            )}

            {/** MODAL VISA **/}
            <div className={styles['w3-container']}>
                <div className={styles['w3-modal']} style={{ display: localState.visa.mostrarFormulario ? 'block' : 'none' }}>
                    <div className={styles['w3-modal-content']} >
                        <div className={styles['w3-header']} />
                        <div className={styles['w3-container']} style={{ padding: '0.5em 1em 1.5em 1em' }}>
                            {/*Logica para ocultar nro tarjeta cuando el pago es denegado*/}
                            <div style={localState.visa.errorVisa !== null && localState.visa.errorVisa.includes("Not Authorized Tarjeta no valida")
                                ? { display: 'none' } : {}}
                            >
                                <div className={styles['titulo']}>
                                    <p className={styles['w3title']}>Pago de Visa</p>
                                    <img alt='' src={imagenNiubiz} className={styles['logoNuibiz']} />
                                </div>
                                <div className={`${styles['flex-container']}`}>
                                    {/* Tipo de documento */}
                                    <div className={`${styles['flex10']}`}>
                                        <label>Número de Tarjeta</label>
                                        <div id="txtNumeroTarjeta" className="form-control"></div>
                                    </div>
                                </div>
                                <div className={`${styles['flex-container']}`}>
                                    {/* Numero de documento */}
                                    <div className={styles['flex5']}>
                                        <label>Fecha de Vencimiento</label>
                                        <div id="txtFechaVencimiento" className="form-control"></div>
                                    </div>
                                    {/* Numero de documento */}
                                    <div className={styles['flex5']}>
                                        <label>CVV</label>
                                        <div id="txtCvv" className="form-control"></div>
                                    </div>
                                </div>
                            </div>


                            {/*Logica para mostrar pago denegado en niubiz*/}
                            {localState.visa.errorVisa !== null && localState.visa.errorVisa.includes("Not Authorized Tarjeta no valida") ?
                                <div style={{ marginBottom: '3%' }}>
                                    <div className={styles['titulo']}>
                                        <p className={styles['w3title2']}>Denegación de pago</p>
                                    </div>
                                    <div className={`${styles['flex-container2']}`}>
                                        <div className={styles['flex5']}>
                                            <label>Número de pedido</label>
                                            <span>{localState.visa.numeroPedido}</span>
                                        </div>
                                        <div className={styles['flex5']}>
                                            <label>Fecha y hora del pedido</label>
                                            <span>{`${moment(new Date()).format('DD-MM-YYYY')} ${moment(new Date()).format('HH:mm:ss')}`}</span>
                                        </div>
                                    </div>
                                    <div className={styles['flex-container2']}>
                                        <div className={styles['flex10']}>
                                            <label>Descripción de la denegación</label>
                                            <span style={{ color: '#E9163C', marginBottom: '3%' }}>
                                                {localState.visa.errorVisa}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                : localState.visa.errorVisa !== null &&
                                <div className={styles['div-error']}>
                                    <span className={styles['span-error']}>
                                        {localState.visa.errorVisa}
                                    </span>
                                </div>
                            }

                            {localState.visa.errorVisa !== null && localState.visa.errorVisa.includes("Not Authorized Tarjeta no valida") ?
                                <div style={{ textAlign: 'center' }}>
                                    <button
                                        className={`${styles['flex5']} ${styles['default']} ${styles['call-to-action']}`}
                                        onClick={pagarDeNuevo}
                                    >
                                        Salir
                                    </button>
                                </div>
                                :
                                <div className={`${styles['flex-container']} ${styles['reverse']}`}>
                                    <button
                                        className={`${styles['flex5']} ${styles['default']} ${styles['call-to-action']}`}
                                        onClick={pagarVisa}
                                    >
                                        Pagar {data.currency} {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                    </button>
                                    <button
                                        className={`${styles['flex5']} ${styles['default']}`}
                                        onClick={reiniciarPagoVisa}
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Pago